const PaymentStatusOptions = [
  {
    label: 'Paid',
    value: 'paid',
    color: 'success',
  },
  {
    label: 'Unpaid',
    value: 'unpaid',
    color: 'critical',
  },
  {
    label: 'Partially Paid',
    value: 'partially_paid',
    color: 'warning',
  },
  {
    label: 'Refunded',
    value: 'refunded',
    color: 'info',
  },
  {
    label: 'Partially Refunded',
    value: 'partially_refunded',
    color: 'info',
  },
]

export default PaymentStatusOptions
